import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from "vue";
import ChannelIndex from "./components/ChannelIndex.vue";
import ChannelAcc from "./components/ChannelAcc.vue";
import ChannelDomain from "./components/ChannelDomain.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelAds',
  props: {
  isRefresh: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const activeKey = ref("1");
const loading = ref(false);
const accountId = ref("");
const props = __props;

const tabClick = (key: string) => {
  activeKey.value = key;
};
const handleSwitchTab = (id: string) => {
  activeKey.value = "1";
  accountId.value = id;
};
const tabComponent = computed(() => {
  if (activeKey.value === "1") return ChannelIndex;
  if (activeKey.value === "2") return ChannelAcc;
  if (activeKey.value === "3") return ChannelDomain;
  return ChannelIndex; // fallback
});

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    activeKey: activeKey.value,
    "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
    onTabClick: tabClick
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tab_pane, {
        key: "1",
        tab: "通道广告",
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(ChannelIndex, {
            accountId: accountId.value,
            "is-refresh": __props.isRefresh,
            activeKey: activeKey.value
          }, null, 8, ["accountId", "is-refresh", "activeKey"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_tab_pane, {
        key: "2",
        tab: "通道账号",
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(ChannelAcc, {
            onSwitchTab: handleSwitchTab,
            "is-refresh": __props.isRefresh
          }, null, 8, ["is-refresh"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_a_tab_pane, {
        key: "3",
        tab: "通道域名",
        disabled: loading.value
      }, {
        default: _withCtx(() => [
          _createVNode(ChannelDomain, { "is-refresh": __props.isRefresh }, null, 8, ["is-refresh"])
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["activeKey"]))
}
}

})